import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { buildPriceHistory } from '../../utils/history-builder';
import { Divider } from '../../components/Divider';
import { Layout } from '../../components/Layout';
import { PriceHistory } from '../../components/PriceHistory';
import { SubscribeLink } from '../../components/SubscribeLink';
import { Title } from '../../components/Title';
import { Valuation } from '../../components/Valuation';
export var PriceHistoryWidget = /*#__PURE__*/function (_React$Component) {
  _inherits(PriceHistoryWidget, _React$Component);

  function PriceHistoryWidget(props) {
    var _this;

    _classCallCheck(this, PriceHistoryWidget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceHistoryWidget).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (e) {
      var _e$currentTarget = e.currentTarget,
          scrollTop = _e$currentTarget.scrollTop,
          clientHeight = _e$currentTarget.clientHeight,
          scrollHeight = _e$currentTarget.scrollHeight;

      if (_this.props.onScrolled && scrollTop + clientHeight === scrollHeight) {
        _this.props.onScrolled();
      }

      if (_this.props.onScroll) {
        _this.props.onScroll();
      }
    });

    _this.state = {
      events: buildPriceHistory(props.events.slice())
    };
    return _this;
  }

  _createClass(PriceHistoryWidget, [{
    key: "render",
    value: function render() {
      return React.createElement(Layout, null, React.createElement(React.Fragment, null, React.createElement(Title, {
        title: this.props.title
      }), React.createElement(Divider, null), React.createElement(PriceHistory, {
        dealType: this.props.dealType,
        events: this.state.events,
        onScroll: this.handleScroll
      }), (this.props.showSubscribeLink || this.props.valuation) && React.createElement(Divider, null), this.props.showSubscribeLink && React.createElement(SubscribeLink, {
        onClick: this.props.onSubscribeLinkClick
      }), this.props.valuation && React.createElement(Valuation, this.props.valuation)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      return {
        events: buildPriceHistory(props.events.slice())
      };
    }
  }]);

  return PriceHistoryWidget;
}(React.Component);